<template>
  <b-modal
    id="documentUploadHistoryModal"
    ref="documentUploadHistoryModal"
    :no-enforce-focus="true"
    :no-close-on-backdrop="true"
    :scrollable="true"
    size="xl"
    @hidden="modalDocumentUploadHistoryHidden"
  >
    <div slot="modal-title">
      {{ title }}
      <span class="ml-2">-</span>
      <span class="font-weight-bold ml-2">{{ `${this.uploadDocumentName} - ${this.uploadOrganizationName}` }}</span>
    </div>
    <UploadDocumentHistoryList :upload-document-id="uploadDocumentId "/>
    <div slot="modal-footer">
      <b-btn class="mr-2" variant="primary" @click="modalDocumentUploadHistoryHidden">
        {{ 'OK' | translate }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import UploadDocumentHistoryList from './UploadDocumentHistoryList'

export default {
  name: 'DocumentUploadHistoryModal',
  components: { UploadDocumentHistoryList },
  props: {
    uploadDocumentId: { required: true },
    uploadDocumentName: { required: true },
    uploadOrganizationName: { required: true }
  },
  mounted () {
    this.openDocumentUploadHistoryModal()
  },
  computed: {
    title () {
      return `${this.$t('History')} ${this.$t('Document')}`
    }
  },
  methods: {
    // MODAL
    openDocumentUploadHistoryModal () {
      this.$refs.documentUploadHistoryModal.show()
    },
    modalDocumentUploadHistoryHidden () {
      this.$emit('close')
      this.$refs.documentUploadHistoryModal.hide()
    },
    onSubmit () {
      this.$emit('submit', this.form.file)
      this.modalDocumentUploadHistoryHidden()
    }
  }
}
</script>
